// @flow

import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import Section from "./Section";

type Props = {
  id: number,
  handleOpenModal: Function,
};

const SortableItem = ({ id, handleOpenModal }: Props) => {
  const {
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Section
      id={id}
      handleOpenModal={handleOpenModal}
      setNodeRef={setNodeRef}
      style={style}
      dragHandleRef={setActivatorNodeRef}
      dragHandleListeners={listeners}
      isDragging={isDragging}
    />
  );
};

export default SortableItem;
